import Box from '@mui/material/Box';
import { QueryClientProvider } from 'react-query';
import { sharedQueryClient } from '../../../queryClient';
import { TeleobjectsPage } from './TeleobjectsPage';

export function CommunicationTeleobjectsPage() {
    return (
        <QueryClientProvider client={sharedQueryClient}>
            <Box
                sx={{
                    marginTop: 1,
                    marginRight: 3,
                }}
            >
                <TeleobjectsPage />
            </Box>
        </QueryClientProvider>
    );
}
